var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import TextClickToCopy from '../TextClickToCopy.vue';
let ContactPhoneRows = class ContactPhoneRows extends Vue {
    constructor() {
        super(...arguments);
        this.tooltipStyle = `
    font-size:14px; background-color:#9EB3DC; min-width:180px; padding:.8rem;
  `;
    }
    formatPhoneNumber(phone) {
        if (!phone)
            return '';
        let cleanedPhone = phone.toString().replace(/\D/g, '');
        // Se tem 12 ou 13 dígitos e começa com 55, é o código do país.
        // Se tem 10 ou 11 e começa com 55, é o DDD 55 (RS).
        if (cleanedPhone.startsWith('55') &&
            [12, 13].includes(cleanedPhone.length)) {
            cleanedPhone = cleanedPhone.substring(2);
        }
        // Existem alguns casos onde tem um zero na frente do ddd
        if (cleanedPhone.startsWith('0')) {
            cleanedPhone = cleanedPhone.substring(1);
        }
        // Verifica se sobrou o tamanho correto (DDD + Número)
        // caso seja menor que 10 podemos assumir que não tem ddd
        // Retornamos ele sem formatação para não exibir um buraco em branco na tela
        if (cleanedPhone.length < 10)
            return phone;
        const ddd = cleanedPhone.substring(0, 2);
        const body = cleanedPhone.substring(2);
        const breakIndex = body.length == 8 ? 4 : 5;
        const first = body.substring(0, breakIndex);
        const second = body.substring(breakIndex);
        return `(${ddd}) ${first}-${second}`;
    }
    get validPhones() {
        return this.allPhones.filter(phone => phone.validation !== 'nao existe');
    }
    get invalidPhones() {
        return this.allPhones.filter(phone => phone.validation === 'nao existe');
    }
    validationInfo(phone) {
        switch (phone.validation) {
            case 'atendido':
                return {
                    icon: 'icon-check-validation',
                    label: 'Telefone atendido',
                };
            case 'nao atende':
                return {
                    icon: 'icon-check-no-call',
                    label: 'Telefone não atendido',
                };
            case 'nao existe':
                return {
                    icon: 'icon-invalid-validation',
                    label: 'Telefone inválido',
                };
            case 'unknow':
                return {
                    icon: 'icon-unknow-validation',
                    label: 'Telefone não verificado',
                };
            default:
                return {
                    icon: 'icon-phone-not-requested',
                    label: this.isInSearchPage
                        ? 'Exporte esta empresa para uma lista para obter a validação'
                        : 'Telefone ainda não validado, solicite a validação para obter um resultado',
                };
        }
    }
    get isInSearchPage() {
        return window.location.href.includes('/search');
    }
};
__decorate([
    Prop({ default: () => { } })
], ContactPhoneRows.prototype, "allPhones", void 0);
ContactPhoneRows = __decorate([
    Component({
        components: { TextClickToCopy },
    })
], ContactPhoneRows);
export default ContactPhoneRows;
